import { toSvg } from 'html-to-image';

export interface SvgExportOptions {
  cacheBust?: boolean;
  backgroundColor?: string;
  width?: number;
  height?: number;
}

/**
 * Render a DOM node as an SVG data URL.
 */
export async function renderNodeAsSvg(
  node: HTMLElement,
  options: SvgExportOptions = {},
): Promise<string> {
  return toSvg(node, {
    cacheBust: true,
    backgroundColor: '#ffffff',
    ...options,
  });
}

/**
 * Trigger a browser download for an SVG data URL.
 */
export function deliverSvg(svgDataUrl: string, filename: string): void {
  const link = document.createElement('a');
  link.download = filename;
  link.href = svgDataUrl;
  link.click();
}
